import { Box, Typography } from 'bonfire-kindling';
import { useTranslation } from 'react-i18next';

export default function PreviewOpportunitiesEmpty() {
  const { t } = useTranslation();

  return (
    <Box margin="auto" width="50%">
      <Box textAlign="center">
        <Typography paragraph variant="h1" component="h2">
          {t('preview.empty.no_opportunities')}
        </Typography>
        <Typography paragraph variant="h4" component="p">
          {t('preview.empty.try_adjusting_search_or_filter')}
        </Typography>
        <Typography paragraph variant="body2" component="p">
          {t('preview.empty.still_no_opportunities')}
        </Typography>
      </Box>
    </Box>
  );
}
